export default "__VITE_ASSET__w7fwHsvP__"